import React from "react";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";
export default class WorkdocOrder extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qa("/order/item/list", {
      filter: { documentid: this.props.id },
      orderby: ["itemid ASC"],
    });

    this.setState({ pending: false, items });
  };
  render() {
    const { items, pending } = this.state;
    const document = this.props.document || {};
    return (
      <>
        <Blocker on={pending} hAuto>
          <h5>{document.label}</h5>
          <div className="mb-4">
            <div>
              Место хранения:{" "}
              <span className="text-muted">{document.storagename}</span>
            </div>
            {document.description && (
              <div>
                Комментарий:{" "}
                <span className="text-muted">{document.description}</span>
              </div>
            )}
          </div>
          <table className="table">
            <tbody>
              {items.map((item) => {
                let model = item.model || {};
                let currency = item.currency || {};
                let measure = item.measure || {};
                return (
                  <tr key={item.itemid}>
                    <td width="50%">
                      {model.name}{" "}
                      <div className="small text-muted">{item.description}</div>
                    </td>
                    <td className="text-nowrap">
                      {item.volume}{" "}
                      <span className="small text-muted">{measure.name}</span>
                    </td>
                    <td className="text-nowrap">
                      {item.price}{" "}
                      <span className="small text-muted">{currency.name}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Blocker>
      </>
    );
  }
}
